<template>
	<el-container>
		<el-main>
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">待定语料</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="top">
				<div style="width: 400px;">
					<el-input size="mini" placeholder="输入关键字搜索" suffix-icon="el-icon-search" v-model="input1" @input="inputNothing"></el-input>
				</div>
				<div class="button">
					<div><el-button type="primary" @click="clickMrark" size="mini" class="item_font">批量标注</el-button></div>
					<div>
						<el-button type="primary" @click="clickImport" size="mini" class="item_font">导入</el-button>
					</div>
				</div>
			</div>
			<div style="width: 80%;height: 550px;margin-top: 20px;" class="item_font">
				<el-table stripe :data="tableData" border highlight-current-row style="width: 100%" :header-cell-style="headerStyle" :cell-style="cellStyle" @selection-change="handleSelectionChange">
					<el-table-column  type="selection" width="55"> <!-- :selectable='checkbox_callback' @selection-change="handleSelectionChange"-->
					</el-table-column>
					<el-table-column  property="createTime" label="访问时间" width="200">
					</el-table-column>
					<el-table-column property="source" label="来源" width="100">
					</el-table-column>
					<el-table-column property="keyword" label="关键词" >
					</el-table-column>
					<el-table-column property="query" label="搜索问句" >
					</el-table-column>
				</el-table>
			</div>
			<div v-if="theme===true">
				<el-dialog title="选择话题" :visible.sync="theme" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" center @close="closeThemeDia">
					<div style="margin: 0 auto;">
						<div style="width: 80%;margin: 0 auto;" class="item_font">
							<!-- :fetch-suggestions="querySearch" @select="handleSelect" @input="inputNothing" -->
							<!-- <el-autocomplete   :trigger-on-focus="false"> -->
								<!-- <template slot-scope="{ item }">
									<div class="name">{{ item.realName }}</div>
								</template> -->
							<!-- </el-autocomplete> -->
							<el-input class="inline-input" 
							style="width: 100%;" 
							size="medium" 
							suffix-icon="el-icon-search" 
							v-model="themeName"  
							placeholder="输入主题名字"
							@input="selectTreeByName"></el-input>
						</div>
						<div style="height: 300px;width: 80%;margin: 0 auto;" class="item_font">
							<el-table 
							:data="themeLst" 
							style="width: 100%;" 
							:cell-style="cellStyle1" 
							height="300" 
							row-key="id"
							@row-click="checkUser" 
							:row-class-name="tableRowClassName"
							:tree-props="{children: 'children', hasChildren: 'hasChildren'}"
							:indent="10" >
								<el-table-column prop="name" label="" min-width="20%" row-key="id" ></el-table-column>
							</el-table>
						</div>
					</div>
					<!-- <span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="user = false">确 定</el-button>
					</span> -->
				</el-dialog>
			</div>
			
			<div v-show="showImport">
				<el-dialog title="上传文件到服务器" :visible.sync="showImport" width="40%" :close-on-click-modal="false" :close-on-press-escape="false">
					<el-upload class="upload-demo" :action="urlPath" :on-success="upSuccess" :data="importType" :headers="myHeaders" :on-change="handleChange"
					:file-list="fileList" :before-upload="beforeUpload" accept=".xlsx,.xls" style="width: 60%;margin: 0 auto;margin-bottom: 3.125rem;">
						<el-button size="small" type="primary" class="item_font">点击上传文件</el-button>
						<div slot="tip" class="el-upload__tip">只能上传excel文件</div>
					</el-upload>
				</el-dialog>
			</div>
			
		</el-main>
		<el-footer>
			<!-- <div style="width: 80px; margin: 0 auto;margin-top: 30px;"><el-button type="primary" @click="save">保存</el-button></div> -->
			<div style="display: flex;flex-direction: row;width: 60%;margin-left: 10%;margin-top: 3%;justify-content: space-around;">
				<el-pagination background :pager-count='9' :page-size="500" layout="prev, pager, next, total" :total="total"
				@prev-click="pre" @next-click="next" @current-change="handleCurrentChange"> </el-pagination>
			</div>
		</el-footer>
	</el-container>
</template>

<script>
	import {MessageBox} from 'element-ui';
	export default {
		name:'indeterminate',
		data() {
			return {
				total:0,
				input1:"",
				theme:false,
				tableData:[
				],
				// urlPath:JSON.parse(localStorage.getItem("siteObj")).webUrl+'/manager/fileInfo/pass/upload',
				urlPath:process.env.VUE_APP_BOTURL+"/talkrobot/corpus/excelImport",
				// urlPath:'http://192.168.0.182:8060/talkrobot/corpus/excelImport',
				myHeaders:{Authorization:localStorage.getItem("token")},
				themeName:"",
				themeLst:[],
				seclectLst:[],
				showImport:false,
				importType:{
					userId:this.util.getLocalAccount().id
				},
				fileList:[],
				corpusData:{
					id:"",
					query:"",
					keyword:"",
					topicId:"",
					userId:this.util.getLocalAccount().id,   
					source:"",
					current:1,
					size:500
				},
				checkTopicId:"",
				checkIds:[],
			}
		},
		mounted() {
			this.corpuSelect()
		},
		
		methods:{
			async corpuSelect(){
				var api = "/manager/corpus/select"
				const response = await this.util.postRequest({
					itype:"1",
					url: api,
					method: "POST",
					data: this.corpusData,
				})
				if(response.resultCode=="10000"){
					this.tableData=response.data.data.corpusSelectVoList
					this.total = response.data.data.total
					for(var i = 0; i < this.tableData.length; i++){
						if(this.tableData[i].source==1){
							this.tableData[i].source="百度"
							this.tableData[i].createTime = this.tableData[i].createTime.replace("T"," ").replace(".000+0000","")
						}
					}
				}else{
					this.$message.error(response.desc)
				}
			},
			
			headerStyle({columnIndex}) {
				if(columnIndex===1){
					return 'text-align:left;color:#000000;'
				}else if(columnIndex===0){
					return 'text-align:right;border-right:none;padding-right:5px;'
				}else{
					return 'text-align:left;padding:15px;color:#000000;'
				}
			},
			cellStyle({columnIndex}) {
				if(columnIndex===1){
					return 'text-align:left;'
				}else if(columnIndex===0){
					return 'text-align:right;border-right:none;padding-right:0;'
				}else{
					return 'text-align:left;padding:15px;'
				}
			},
			cellStyle1() {
				return 'text-align:left;height:20px;line-height:20px'
			},
			closeThemeDia(){
				this.theme=false
				this.checkIds=[]
				this.themeName=""
				// console.log("选定语料集合",this.checkIds)
			},
			async inputNothing(val) {
				console.log("输入值发生改变",val)
				this.corpusData.keyword=val
				this.corpuSelect()
			},
			selectTreeByName(){
				this.clickMrark()
			},
			async clickMrark() {
				if (this.seclectLst.length===0) {
					this.open2()
				} else{
					this.theme=true
					for(var i = 0; i < this.seclectLst.length; i++){
						this.checkIds.push(this.seclectLst[i].id)
					}
					
					var api = "/manager/topic/selectTree"
					const response = await this.util.postRequest({
						itype:"1",
						url: api,
						method: "POST",
						data: {
							name:this.themeName,
							userId:this.util.getLocalAccount().id
						}
					})
					console.log(response.data)
					if(response.resultCode=="10000"){
						this.themeLst = response.data
					}else{
						this.$message.error(response.desc)
					}
				}
			},
			clickImport() {
				this.showImport=true
			},
			handleSelectionChange(rows) {
				console.log("handleSelectionChange",rows)
				this.seclectLst=rows
			},
			save() {
				
			},
			handlePreview(file) {
				console.log('handlePreview',file);
			},
			// handleExceed(files, fileList) {
			// 	this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			// },
			beforeUpload(file) {
				console.log('beforeUpload',file)
				const isJPG = file.type === 'excel' || 'xls' || 'xlsx'
				const isLt10M = file.size <  1024 * 1024 * 10;
				if (!isJPG) {
					this.$message.error('上传文件只能是excel/xls/xlsx格式!')
					return false
				}
				if (!isLt10M) {
					this.$message.error('上传的文件大小不能超过 10MB!');
					return false
				}
			},
			uploadVedios(event, file, fileList) {
				let size = file.size;
				console.log('文件上传uploadVedios',event, file, fileList,size)
				// this.editSoundParameter(this.selfId1,'自定义1','url1')
			},
			handleChange(info) {
				console.log("handleChange",info)
			},
			upSuccess(res,file){
				console.log("upSuccess1",res,file)
				if(res.resultCode=="10000"){
					this.showImport=false
					this.corpuSelect()
				}else{
					this.$message.error(res.desc)
				}
				
				
				// if(res.resultCode==="10000"){
				// 	var url = this.util.getLocalImgUrl() + res.data.fileUrl
				// 	this.src1 = url
				// 	console.log(url)
				// 	this.$message.success("上传成功");
				// }else{
				// 	this.$message.error("上传失败，请重新上传");
				// }
			},
			tableRowClassName ({row, rowIndex}) {
				row.index = rowIndex;
			},
			checkUser(row) {
				console.log("*** checkUser ***",row,this.index)
				// console.log("@@@ checkHistory @@@",column)
				// console.log("### checkHistory ###",event)
				this.checkTopicId = row.id
				
				this.show = true
				this.open1()
			},
			async open1() {
				MessageBox.alert("是否确认标记", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(()=>{
					this.corpusMark()
				}).catch(()=>{
					this.$message.info("取消标记")
				})
			},
			
			async corpusMark(){
				var api = "/manager/corpus/mark"
				const response = await this.util.postRequest({
					itype:"1",
					url: api,
					method: "POST",
					data: {
						topicId:this.checkTopicId,
						corpusIds:this.checkIds
					}
				})
				if(response.resultCode=="10000"){
					this.themeName=""
					this.theme=false
					this.corpuSelect()
					this.checkIds=[]
				}else{
					this.$message.error(response.desc)
				}
			},
			
			
			open2() {
				const text = '请选择要标记的数据'
				MessageBox.alert(text, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: null,
					type: "warning",
					showCancelButton: false,
				});
			},
			formatDate(date){
				date = new Date(Date.parse(date.replace(/-/g,"/")))
				var y = date.getFullYear()
				var m = date.getMonth()+1
				m = m<10 ? "0"+m : m
				var d = date.getDate()
				d = d < 10 ? "0"+d : d;
				return y + "-" + m + "-" + d;
			},
			
			pre(info) {
				console.log("pre：", info)
				this.corpusData.current=info
				this.corpuSelect()
			},
			next(info) {
				console.log("next：", info)
				this.corpusData.current=info
				this.corpuSelect()
			},
			handleCurrentChange(val) {
				this.start = 4 * (val - 1)
				this.corpusData.current = val
				
				this.corpuSelect()
				console.log("当前页码：", val, this.start)
			},
		}
	}
</script>

<style lang="scss">
	.top{
		display: flex;
		flex-direction: row;
		justify-content: space-between; 
		margin-top: 15px;
		width: 80%;
	}
	.button{
		width: 150px; 
		margin-top: 5px;
		display: flex;
		flex-direction: raw;
		justify-content: space-between;
	}
	.el-upload__tip{
		@include change_size($font_size_normal)
	}
</style>
